<script>
  import { isArray } from 'lodash'
  import LoteRestricoesService from '../../../../../domain/leiloes/services/lote-restricoes'
  import RestricoesService from '../../../../../domain/tipo-restricao/services/tipo-restricao'
  import PopupViewer from '../../../../_default/components/popup-viewer/PopupViewer'

  export default {
    name: 'novo-lote-restricoes',
    components: {
      PopupViewer,
      NovoTipoLoteRestricoes: () => import('./NovoTipoLoteRestricoes')
    },
    props: {
      restricaoId: {
        type: Number,
        required: false,
        default: null
      }
    },
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        restricao: null,
        tiposRestricao: [],
        showTipoRestricaoForm: false,
        oldRestricao: null
      }
    },
    created () {
      this.carregarTiposRestricao()
    },
    methods: {
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$bar.start()
        this.$parent.loading(true)
        LoteRestricoesService.cadastroRestricaoLote(this.$route.params.id, this.restricao, this.oldRestricao)
          .then((response) => {
            let callbackEnd = () => {
              this.$emit('finishSubmit')
            }
            callbackEnd()
          }).catch((response) => {
            this.cadastroError = response.data.errors
            this.$nextTick(() => {
              this.$refs.error.focus()
            })
            console.log(response)
          })
          .finally(() => {
            this.$bar.finish()
            this.$parent.loading(false)
          })
      },
      carregarTiposRestricao () {
        this.$parent.loading(true)
        RestricoesService.listAll()
          .then(response => {
            this.tiposRestricao = response.data
            this.oldRestricao = this.restricao = this.restricaoId
          })
          .catch(error => {
            this.cadastroError = error.data.errors
          })
          .finally(() => {
            this.$parent.loading(false)
            this.isLoaded = true
          })
      },
      openTipoRestricaoForm () {
        this.showTipoRestricaoForm = true
      },
      closeTipoRestricaoForm () {
        this.showTipoRestricaoForm = false
      },
      finishSubmitCadastroTipoRestricao () {
        this.closeTipoRestricaoForm()
        this.carregarTiposRestricao()
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Gerenciamento de Restrições</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{restricaoId && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent="submit" class="bs-example form-horizontal">

              <div class="form-group">
                <label class="col-sm-4 control-label">Tipo</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="restricao" required>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="restricao.id" v-for="restricao in tiposRestricao" :key="restricao.id">{{restricao.nome}}</option>
                  </select>
                  <!--<u-button class="btn btn-xs pull-right m-t-sm m-b-xs m-r-xs btn-default" @click="openTipoRestricaoForm">
                    <i class="fa fa-plus"></i> Cadastrar tipo de débito
                  </u-button>-->
                  <router-link :to="{name: 'config.tipo-restricao.novo'}" target="_blank" class="btn btn-xs pull-right m-t-sm m-b-xs m-r-xs btn-default">
                    <i class="fa fa-plus"></i> Cadastrar nova restrição
                  </router-link>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button class="btn m-b-xs w-xs btn-info m-r-xs" type="submit">
                  <span v-if="!restricaoId">Cadastrar</span>
                  <span v-if="restricaoId">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$emit('cancel')">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <popup-viewer @close="closeTipoRestricaoForm" v-if="showTipoRestricaoForm" :title="`Cadastro de Tipo de Restricao`">
        <NovoTipoLoteRestricoes @cancel="closeTipoRestricaoForm" @finishSubmit="finishSubmitCadastroTipoRestricao" />
      </popup-viewer>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovoLoteRestricao.vue?5aefd43a